// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthLayout_content__c1WgL"};